import {
  AlertTriangle,
  HelpCircle,
  Lightbulb,
  MessageSquare,
  Sparkles,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import type {
  FeedbackCategory,
  FeedbackStatus,
} from "@stockline/shared/types/core/feedback";

export interface CategoryMeta {
  icon: LucideIcon;
  className: string;
  ring: string;
}

/**
 * Soft-tinted palette — pills sit on cards without competing with content.
 * Each entry: bg+text tailwind classes for the pill, plus a `ring` color for
 * the selected-state outline in the composer category picker.
 */
export const CATEGORY_META: Record<FeedbackCategory, CategoryMeta> = {
  error: {
    icon: AlertTriangle,
    className: "bg-red-50 text-red-700 ring-1 ring-inset ring-red-200",
    ring: "ring-red-300",
  },
  issue: {
    icon: Wrench,
    className: "bg-orange-50 text-orange-700 ring-1 ring-inset ring-orange-200",
    ring: "ring-orange-300",
  },
  ask: {
    icon: MessageSquare,
    className: "bg-violet-50 text-violet-700 ring-1 ring-inset ring-violet-200",
    ring: "ring-violet-300",
  },
  improvement: {
    icon: Sparkles,
    className: "bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-200",
    ring: "ring-sky-300",
  },
  idea: {
    icon: Lightbulb,
    className: "bg-lime-50 text-lime-700 ring-1 ring-inset ring-lime-200",
    ring: "ring-lime-300",
  },
  question: {
    icon: HelpCircle,
    className: "bg-slate-50 text-slate-700 ring-1 ring-inset ring-slate-200",
    ring: "ring-slate-300",
  },
};

export interface StatusMeta {
  className: string;
  dot: string;
}

export const STATUS_META: Record<FeedbackStatus, StatusMeta> = {
  open: {
    className: "bg-amber-50 text-amber-800 ring-1 ring-inset ring-amber-200",
    dot: "bg-amber-500",
  },
  in_progress: {
    className: "bg-blue-50 text-blue-800 ring-1 ring-inset ring-blue-200",
    dot: "bg-blue-500",
  },
  addressed: {
    className:
      "bg-emerald-50 text-emerald-800 ring-1 ring-inset ring-emerald-200",
    dot: "bg-emerald-500",
  },
  closed: {
    className: "bg-slate-50 text-slate-600 ring-1 ring-inset ring-slate-200",
    dot: "bg-slate-400",
  },
};
